import { Maybe } from "types/Maybe"

export const getLayoutStyles = (
  imageStartsOn: Maybe<string> = "left",
  indexIsEven: boolean
): string[] => {
  let desktopAreas = ""
  switch (imageStartsOn) {
    case "right":
      desktopAreas = indexIsEven ? "'text img'" : "'img text'"
      break
    default:
      desktopAreas = indexIsEven ? "'img text'" : "'text img'"
  }

  return ["'img' 'text'", "'img' 'text'", desktopAreas]
}

export const getXPadding = (
  imageStartsOn: Maybe<string>,
  indexIsEven: boolean
): string[] => {
  let variablePadding = []

  if (imageStartsOn === "left") {
    variablePadding = indexIsEven
      ? ["75px 40px 0 0", "0 40px 0 0"]
      : ["75px 0 0 40px", "0 0 0 40px"]
  } else {
    variablePadding = indexIsEven
      ? ["75px 0 0 40px", "0 0 0 40px"]
      : ["75px 40px 0 0", "0 40px 0 0"]
  }

  const allPadding = ["0", ...variablePadding]

  return allPadding
}

export const getTextPadding = (
  imageStartsOn: Maybe<string>,
  indexIsEven: boolean
): string[] => {
  let variablePadding = []

  if (imageStartsOn === "left") {
    variablePadding = indexIsEven
      ? ["50px 40px 50px 80px", "85px 40px 85px 22%"]
      : ["50px 80px 50px 40px", "85px 22% 85px 40px"]
  } else {
    variablePadding = indexIsEven
      ? ["50px 80px 50px 40px", "85px 22% 85px 40px"]
      : ["50px 40px 50px 80px", "85px 40px 85px 22%"]
  }

  const allPadding = ["30px 40px 0", "50px 50px 0", ...variablePadding]

  return allPadding
}
